<template>
  <MapboxLayer
    id="hydrography"
    :options="{
      source: {
        id: 'hydrografie-source',
        type: 'raster',
        tileSize: 512,
        tiles: [
          // 'https://service.pdok.nl/hwh/hydrografie/wms/v1_0?SERVICE=wms&REQUEST=GetMap&VERSION=1.3.0&LAYERS=HY.PhysicalWaters.Waterbodies&STYLES=HY.PhysicalWaters.Waterbodies.Default&CRS=EPSG:3857&BBOX={bbox-epsg-3857}&width=512&height=512&format=image/png',
          'https://wms-proxy.septemberdev.nl/service?REQUEST=GetMap&VERSION=1.3.0&LAYERS=HY.PhysicalWaters.Waterbodies&STYLES=&CRS=EPSG:3857&BBOX={bbox-epsg-3857}&width=512&height=512&format=image/png',
        ],
      },
      type: 'raster',
      id: 'hydrografie-layer',
      paint: {
        'raster-opacity': 0.4
      },
    }"
  />
</template>

<script>
import {MapboxLayer} from "@studiometa/vue-mapbox-gl";

export default {
  name: "HydrographyLayer",
  components: {
    MapboxLayer,
  },
  data(){
    return {
    };
  }
}
</script>

<style scoped>

</style>
